module.exports = __webpack_public_path__ + "media/images/products/retailers-customised-8-sample05-d1b2208582c8106fa4c0e2fa1602f169.jpg";